export * from './Figcaption';
